import { render, staticRenderFns } from "./DeleteResource.vue?vue&type=template&id=e88e1d9c&"
import script from "./DeleteResource.vue?vue&type=script&lang=js&"
export * from "./DeleteResource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports